module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-progress-bar')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-963a93d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notification.vue
// module id = 1021
// module chunks = 2